import apiClient from './apiClient';

export type NotifyEventKey =
  | 'intakeSubmitted'
  | 'quoteApprovalRequested'
  | 'quoteAccepted'
  | 'quoteDeclined'
  | 'quoteChangesRequested';

export interface NotifyEventDef {
  key: NotifyEventKey;
  label: string;
  description: string;
  audience: 'lab' | 'client' | 'creator';
}

export interface NotificationSettings {
  defs: NotifyEventDef[];
  events: Record<NotifyEventKey, boolean>;
  recipients: string[];
  /** Whether the server can actually deliver (SENDGRID_API_KEY present). */
  delivery: { configured: boolean; from: string };
}

export interface TestEmailResult {
  configured: boolean;
  from: string;
  emailSent: boolean;
  to: string[];
  reason: string | null;
}

export const getNotificationSettings = async (): Promise<NotificationSettings> => {
  const response = await apiClient.get<NotificationSettings>('/notifications/settings');
  return response.data;
};

export const updateNotificationSettings = async (
  patch: { events?: Partial<Record<NotifyEventKey, boolean>>; recipients?: string[] },
): Promise<NotificationSettings> => {
  const response = await apiClient.put<NotificationSettings>('/notifications/settings', patch);
  return response.data;
};

export const sendTestEmail = async (): Promise<TestEmailResult> => {
  const response = await apiClient.post<TestEmailResult>('/notifications/test');
  return response.data;
};
